function AsanaError(message) {
  this.message = message;
  try {
    throw new Error(message);
  } catch (e) {
    this.stack = e.stack;
  }
}

AsanaError.prototype = Object.create(Error.prototype);

module.exports = AsanaError;


//////////////////
// WEBPACK FOOTER
// ./node_modules/asana/lib/errors/error.js
// module id = 124
// module chunks = 0